import app from './app.json';
import common from './common.json';
import page from './page.json';
const bn = {
    app,
    common,
    page
};
export default bn;
